
import React from 'react';

import styles from './styles.module.scss'

interface ITextSection {
  header?: string;
  text: string | JSX.Element;
  textLeft?: string | JSX.Element;
  className?: string;
}

export default function TextSection({ header, text, textLeft, className } : ITextSection)  {
  return (
    <div className={`${styles.textSection} ${className} cooler-padding section`}>
      <div className={styles.textHolder}>
        { !!header && 
          <h1 className={styles.textSectionHeader}>{header}</h1>
        }
        { !!textLeft && 
          <p className={styles.textSectionText + " text"}>{ textLeft }</p>
        }
        
        <p className={styles.textSectionText + " text"}>{ text }</p>
      </div>
    </div>
  )
};
